import { Tab } from "@headlessui/react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import React, { FC, Fragment, useEffect, useMemo, useState } from "react";
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import { GuestsObject } from "components/HeroSearchForm/type";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import ModalSelectDate from "components/ModalSelectDate";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ModalSelectGuests from "components/ModalSelectGuests";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { baseURL, socketId } from "configs/axiosConfig";
import Loading from "components/Loading/Loading";

import { dateFormat } from "../../../context/Functionalty";
import { toast } from "react-toastify";
import { stripeCheckoutAction } from "../../../redux/features/orderSlide";
import bookingApi from "api/booking/BookingApi";
import { booking } from "data/business";
import { FaMoneyBillWave, FaMoneyCheckAlt } from "react-icons/fa";

const BookingDetailMainPage = ({ className = "" }) => {
  const params = useParams(); // Whole params object
  // console.log({ params });

  const [bookings, setBookings] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState("cash"); // Default to "cash"

  const getBookingByIdAction = async () => {
    try {
      const id = params?.bookingId; // or bookingId depending on your route
      const { response, err } = await bookingApi.getBookingById({ id });

      if (response) {
        setBookings(response.data); // or response.data.booking if wrapped
      } else {
        throw new Error(err?.message || "Failed to load booking.");
      }
    } catch (error) {
      console.error("Failed to fetch booking:", error);
      setError(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBookingByIdAction();
  }, [params]);

  console.log({ bookings });
  const groupedItems = useMemo(() => {
    const services = bookings?.booking?.selectedServices || [];
    const operatorId = bookings?.booking?.operator?.[0]?._id;

    if (!operatorId || services.length === 0) return {};

    return {
      [operatorId]: services.map((service) => {
        const qty = service.qty || 1;
        const rawPrice = service?._id?.price;

        return {
          ...service,
          operator: operatorId,
          qty,
          price:
            rawPrice !== undefined && rawPrice !== null
              ? parseFloat(rawPrice)
              : 0,
        };
      }),
    };
  }, [bookings]);

  console.log({ groupedItems });

  //---------------------------------------------------------------------

  const booking = bookings?.booking;
  const user = booking?.user;
  const payments = booking?.payments;

  const paymentsStatus = {
    pending: payments?.status === "pending",
    complete: payments?.status === "completed",
    cancelled: payments?.status === "cancelled",
  };

  const Totals = [
    {
      name: "Subtotal",
      cost: `$${booking?.subTotalPrice ?? 0}`,
    },
    {
      name: "Tax",
      cost: `$${booking?.taxprice ?? 0}`,
    },
    {
      name: "Total",
      cost: `$${booking?.totalPrice ?? 0}`,
    },
  ];

  const paymentInfo = [
    {
      title: "Paid Status",
      value: payments?.status || "---",
      bg: true,
    },
    {
      title: "Payment Method",
      value: payments?.paymentMethod || "---",
      bg: false,
    },
    {
      title: "Paid At",
      value: payments?.paymentDate ? dateFormat(payments.paymentDate) : "---",
      bg: false,
    },
  ];

  const userInfos = [
    {
      title: "Customer's Name",
      value: user?.displayName || "---",
    },
    {
      title: "Customer's Email",
      value: user?.username || "---",
    },
    {
      title: "Customer's Phone Number",
      value: user?.phone || "---",
    },
  ];

  const handlePayment = () => {
    // dispatch(
    //   stripeCheckoutAction({
    //     id: order?.order?._id,
    //     orderItems: order?.order?.orderItems,
    //     email: user?.username,
    //   })
    // )
    //   .unwrap()
    //   .then((url) => {
    //     console.log("Stripe Checkout URL:", url);
    //     window.location.href = url;
    //   })
    //   .catch((error) => {
    //     console.error("Payment Error:", error);
    //   });
  };

  const handleDownload = () => {
    toast.error("Not emplemented yet");
  };

  const renderSidebar = () => {
    return (
      <>
        <div className="flex flex-col gap-8 mb-6">
          {Totals.map((t, i) => (
            <div
              key={i}
              className="flex items-center justify-between text-sm w-full font-semibold"
            >
              {t.name}
              <span className="font-bold">{t.cost}</span>
            </div>
          ))}
          <div className="p-1 pl-4 items-center text-gray-800 bg-dryGray border rounded w-full flex justify-between">
            <h2 className="font-semibold text-sm dark:text-white">Total</h2>
            <button
              type="button"
              className="px-8 bg-red-100 py-4 font-bold flex-colo text-sm rounded"
            >
              ${booking?.booking?.totalPrice}
            </button>
          </div>
        </div>
        <>
          {paymentsStatus.pending && (
            <>
              <ButtonPrimary
                onClick={handlePayment}
                className="bg-main py-4 w-full rounded text-white flex-colo"
              >
                Purchase Order
              </ButtonPrimary>
            </>
          )}
          {paymentsStatus.complete && (
            <div className="grid sm:grid-cols-2 gap-6 text-sm">
              <Link
                to="/shop"
                className="border border-main py-4 rounded flex-colo"
              >
                Shop Again
              </Link>
              <ButtonPrimary
                onClick={handleDownload}
                className="bg-main py-4 rounded text-white flex-colo"
              >
                Download Invoice
              </ButtonPrimary>
            </div>
          )}
          {paymentsStatus?.cancelled === "cancelled" && (
            <>
              <p className="text-red-600 text-sm text-center">
                {/* {shipping?.status === "cancelled"
                  ? "Order has been canceled."
                  : "Payment has been canceled."}{" "}
                {"  "} */}
                if you have any question please contact us
              </p>
              <Link
                to="/contact-us"
                className="bg-white py-4 rounded text-main mt-4 border flex-colo"
              >
                Contact Us
              </Link>
            </>
          )}
        </>
      </>
    );
  };

  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    const userId = user?.id;
    if (userId) {
      socketId.emit("addUser", userId);
      socketId.on("getUsers", (data) => {
        setOnlineUsers(data);
      });
    }
  }, [user]);

  // console.log({ onlineUsers });

  const operator = booking?.operator?.[0];

  const deliveryInfo = operator
    ? [
        { title: "Store Name", value: operator.name },
        { title: "Email", value: operator.email },
        { title: "Country", value: operator.country },
        { title: "Address", value: operator.address },
        { title: "Has Loyalty", value: operator.hasLoyalty ? "Yes" : "No" },
        {
          title: "Verified",
          value: operator.additionalInfo?.verified ? "Yes" : "No",
        },
        {
          title: "Instant Confirmation",
          value: operator.additionalInfo?.instantConfirmation ? "Yes" : "No",
        },
        {
          title: "Pay by App",
          value: operator.additionalInfo?.payByApp ? "Yes" : "No",
        },
      ]
    : [];

  const navigate = useNavigate();

  const renderMain = () => {
    const classNames = "text-xs bg-opacity-20 py-1.5 px-4 rounded-full ml-3";
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold text-redlight">
          Detail Booking{" "}
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="w-full space-y-8">
          <div>
            <h3 className="font-semibold text-lg">
              <>
                <span>Your Booking</span>{" "}
                {paymentsStatus?.pending ? (
                  <span
                    className={`text-star bg-reddark dark:bg-reddark text-redlightlight ${classNames}`}
                  >
                    Pending
                  </span>
                ) : paymentsStatus?.complete ? (
                  <span className={`text-green-600 bg-green-600 ${classNames}`}>
                    Complete
                  </span>
                ) : paymentsStatus?.cancelled ? (
                  <span className={`text-red-600 bg-red-600 ${classNames}`}>
                    Cancelled
                  </span>
                ) : (
                  <span className="text-gray-500">Unknown Status</span>
                )}
              </>
            </h3>

            {loading ? (
              <Loading />
            ) : (
              <div className="my-2">
                {!bookings?.booking?.operator ||
                bookings.booking.operator.length === 0 ? (
                  <h4 className="text-center text-xl">Cart is Empty</h4>
                ) : (
                  bookings.booking.operator.map((operator) => {
                    const items = groupedItems[operator._id] || [];

                    const isOperatorOnline = onlineUsers.some(
                      (user) => user.userId === operator._id
                    );

                    // {
                    //   console.log({ isOperatorOnline });
                    // }
                    return (
                      <div key={operator._id} className="rounded p-1">
                        <div className="flex items-center mt-6">
                          <div className="flex-1 flex flex-col justify-between sm:flex-row sm:items-center ">
                            <div className="flex flex-row items-center">
                              <div className="flex-shrink-0 w-20 sm:w-10 md:w-12 lg:w-20 flex flex-col items-center">
                                {/* Avatar container */}
                                <div
                                  className="relative aspect-w-1 aspect-h-1 rounded-full overflow-hidden border-2 shadow border-red-500 w-full"
                                  onClick={() =>
                                    navigate(
                                      `/operator/booking/${operator.slug}`
                                    )
                                  }
                                >
                                  <img
                                    alt=""
                                    className="absolute inset-0 object-cover w-full h-full"
                                    src={operator?.photo || ""}
                                  />
                                </div>

                                {/* Online status BELOW avatar */}
                                <p className="text-sm text-center mt-2 font-semibold">
                                  {isOperatorOnline
                                    ? "🟢 Online"
                                    : "🔴 Offline"}
                                </p>
                              </div>

                              <div className="py-5 px-5 space-y-3">
                                <div>
                                  <span className="text-base font-medium mt-1 block">
                                    {operator?.name || "Unknown"}
                                  </span>
                                  <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
                                    {operator?.email || "Unknown"}
                                  </span>
                                </div>

                                <div className="w-10 border-b border-neutral-200 dark:border-neutral-700"></div>
                                <StartRating />
                              </div>
                            </div>

                            <div className="flex basis-[30px]  justify-end items-start border-b border-neutral-300 dark:border-neutral-700 sm:basis-[80px]">
                              <span className="text-primary-contrastText font-bold ">
                                $
                                {items
                                  .reduce(
                                    (acc, item) => acc + item.price * item.qty,
                                    0
                                  )
                                  .toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* List items */}
                        {items.length === 0 ? (
                          <p>No items for this operator.</p>
                        ) : (
                          items.map((item) => (
                            <div key={item._id} className="border-0 py-1">
                              <div className="flex justify-between px-1 py-1 items-center">
                                <span className="text-primary-contrastText text-sm ml-2">
                                  {item.title}{" "}
                                  <span className="text-xs text-gray-400">
                                    ({item.desc})
                                  </span>{" "}
                                  x <strong>{item.qty}</strong>
                                </span>
                                <div className="flex items-center">
                                  <span className="text-primary-contrastText">
                                    $
                                    {item.price
                                      ? (item.price * item.qty).toFixed(2)
                                      : "0.00"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            )}

            {/* ------------------------------------------------- */}

            <NcModal
              renderTrigger={(openModal) => (
                <span
                  onClick={() => openModal()}
                  className="block lg:hidden underline  mt-1 cursor-pointer"
                >
                  View Totals
                </span>
              )}
              renderContent={renderSidebar}
              modalTitle="Order details"
            />
          </div>
          {/* <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700 overflow-hidden z-10">
            <ModalSelectDate
              renderChildren={({ openModal }) => (
                <button
                  onClick={openModal}
                  className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800"
                  type="button"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Date</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      {converSelectedDateToString([startDate, endDate])}
                    </span>
                  </div>
                  <PencilSquareIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
            /> 

           <ModalSelectGuests
              renderChildren={({ openModal }) => (
                <button
                  type="button"
                  onClick={openModal}
                  className="text-left flex-1 p-5 flex justify-between space-x-5 hover:bg-neutral-50 dark:hover:bg-neutral-800"
                >
                  <div className="flex flex-col">
                    <span className="text-sm text-neutral-400">Guests</span>
                    <span className="mt-1.5 text-lg font-semibold">
                      <span className="line-clamp-1">
                        {`${
                          (guests.guestAdults || 0) +
                          (guests.guestChildren || 0)
                        } Guests, ${guests.guestInfants || 0} Infants`}
                      </span>
                    </span>
                  </div>
                  <PencilSquareIcon className="w-6 h-6 text-neutral-6000 dark:text-neutral-400" />
                </button>
              )}
            /> 
            </div> */}
          {/* user */}
          <div className="bg-dry border p-8 rounded dark:border-border">
            <h2 className="text-md font-semibold mb-4">Customer Infomation</h2>
            {userInfos?.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-2 gap-2 py-5 px-2 border-t border-border "
              >
                <h5 className="text-sm dark:text-neutral-400">{item.title}</h5>
                <p className={`text-xs text-gray-500 dark:text-neutral-300`}>
                  {item?.value ? item.value : "---"}
                </p>
              </div>
            ))}
          </div>
          {/* payment info */}
          <div className="bg-dry border border-border p-8 rounded">
            <h2 className="text-md font-semibold mb-4">Payment Infomation</h2>
            {paymentInfo?.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-2 gap-2 py-5 px-2 border-t border-border"
              >
                <h5 className="text-sm dark:text-neutral-400">{item.title}</h5>
                <p
                  className={`text-xs capitalize ${
                    item.bg
                      ? item.value === "completed"
                        ? " text-green-600"
                        : (item.value === "awaiting") |
                          (item.value === "pending")
                        ? " text-orange-500"
                        : " text-red-600"
                      : " text-text"
                  }`}
                >
                  {item?.value ? item.value : "---"}
                </p>
              </div>
            ))}
          </div>
          {/* delivery Info */}
          <div className="bg-dry border border-border p-8 rounded">
            <h2 className="text-md font-semibold mb-4">Business Address</h2>

            {/* Avatar + name + email */}
            {operator?.photo && (
              <div className="flex items-center mb-4">
                <img
                  src={operator.photo}
                  alt={operator?.name}
                  className="w-16 h-16 rounded-full border border-gray-300 object-cover"
                />
                <div className="ml-4">
                  <h3 className="font-semibold text-base">{operator.name}</h3>
                  <p className="text-xs text-gray-500">{operator.email}</p>
                </div>
              </div>
            )}

            {/* Other fields */}
            {deliveryInfo?.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-2 gap-2 py-5 px-2 border-t border-border"
              >
                <h5 className="text-sm text-textGray">{item.title}</h5>
                <p
                  className={`text-xs capitalize ${
                    item.bg
                      ? item.value === "completed"
                        ? " text-green-600"
                        : item.value === "awaiting" || item.value === "pending"
                        ? " text-orange-500"
                        : item.value === "shipped"
                        ? " text-blue-600"
                        : " text-red-600"
                      : " text-text"
                  }`}
                >
                  {item?.value ? item.value : "---"}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-semibold">Pay with</h3>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>

          <div className="mt-6">
            <Tab.Group
              onChange={(index) => {
                // index 0 = Cash, 1 = Stripe
                setSelectedPayment(index === 0 ? "cash" : "stripe");
              }}
            >
              <Tab.List className="flex my-5 gap-1">
                {/* Cash at Kiosk */}
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full focus:outline-none ${
                        selected
                          ? "bg-neutral-800 dark:bg-neutral-200 text-white dark:text-neutral-900"
                          : "text-neutral-6000 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                      }`}
                    >
                      Cash at Kiosk
                    </button>
                  )}
                </Tab>

                {/* Stripe */}
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full flex items-center justify-center focus:outline-none ${
                        selected
                          ? "bg-neutral-800 dark:bg-neutral-200 text-white dark:text-neutral-900"
                          : "text-neutral-6000 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                      }`}
                    >
                      <span className="mr-2.5">Stripe</span>
                      <img className="w-8" src={visaPng} alt="visa" />
                      <img
                        className="w-8"
                        src={mastercardPng}
                        alt="mastercard"
                      />
                    </button>
                  )}
                </Tab>
              </Tab.List>

              <Tab.Panels>
                {/* Cash Panel */}
                <Tab.Panel className="space-y-5">
                  <div className="bg-redlight p-4 rounded text-white text-sm">
                    You have chosen to pay at the kiosk. Please bring exact cash
                    and your order confirmation.
                  </div>
                </Tab.Panel>

                {/* Stripe Panel */}
                <Tab.Panel className="space-y-5">
                  <div className="space-y-1">
                    <Label>
                      Would you like to switch to secure online payment via
                      Stripe?
                    </Label>
                  </div>
                  <div className="pt-4">
                    <ButtonPrimary
                      className="flex items-center justify-center gap-2"
                      onClick={() => {
                        if (selectedPayment === "stripe") {
                          handlePayment();
                        } else {
                          toast.success("Please pay at the kiosk. Thank you!");
                          // navigate("/pay-done");
                        }
                      }}
                    >
                      {selectedPayment === "stripe" ? (
                        <>
                          <FaMoneyCheckAlt className="text-lg" />
                          Pay Securely with Stripe
                        </>
                      ) : (
                        <>
                          <FaMoneyBillWave className="text-lg" />
                          Confirm and Pay Cash
                        </>
                      )}
                    </ButtonPrimary>
                  </div>
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="container grid xl:grid-cols-[3fr_2fr] gap-6 w-full items-start">
      <div className="w-full space-y-0">{renderMain()}</div>
      <div className="w-full sticky top-28 xl:mt-4 border-[0.5px] border-red-500 rounded-md sm:p-12 p-4">
        {renderSidebar()}
      </div>
    </div>
  );
};

export default BookingDetailMainPage;
